let internalIsMock: boolean = false;
// const mockReg = /127.0.0.1|localhost|dev.sankuai.com/gi;

/**
 * 是否开启 mock
 * @returns {boolean} 是否开启 mock
 */
export function isMock(): boolean {
  return internalIsMock;
}

/**
 * 设置是否开启 mock
 * @param {boolean} isMock 是否开启 mock
 */
export function setIsMock(mock: boolean): void {
  // if (process.env.NODE_ENV !== 'production') {
  //   internalIsMock = isMock;
  // }
  internalIsMock = mock;
}

/**
 * 参数隧道数据
 * https://km.sankuai.com/page/195064302
 */
export function getParamsTunnelData(): any {
  return {
    safe_key_notice_info: {
      show: true,
      url: 'https://p1.meituan.net/pay/cf68119a3812a4e0c966dc8436d52efa2076.png',
    },
    app_name: 'group',
    app_version: '11.0.222',
    device_platform: 'iphone',
    usr_city_id: 1,
    usr_location: 'x.x',
    device_id: 'device_id',
    device_uuid: 'device_uuid',
    app_channel: 'app_channel',
    app_hybrid_cashier_sdk_version: '1.0.24',
    app_pay_sdk_version: '9.3',
    device_fingerprint: 'device_fingerprint',
    device_system_version: '10.0.0',
    device_rooted: 0,
    device_imsi: 'device_imsi',
    neo_sdk_version: 'neo_sdk_version',
    device_manufacturer: 'device_manufacturer',
    device_model: 'MI Note',
    usr_id: 'usr_id',
    usr_token: 'usr_token',
    device_install_apps: 19,
    pay_token: 'pay_token',
    tradeno: '10241024',
    merchant_no: '111',
    pay_success_url: 'pay_success_url',
    redr_url: 'redr_url',
    ext_param: 'ext_param',
    stat_time: `${Date.now() - 800},${Date.now() - 600},${Date.now() - 200}`,
    enable_data_loader: 1,
    enable_native_side_render: 0,
    enable_modal_loading: 1,
    bizt_channel_code: 'bizt_channel_code',
    i_cashier_type: 'i_cashier_type',
    last_resumed_page: 'last_resumed_page',
    hybrid_user_flag: 'base',
    hybrid_downgrade: 0,
    nb_adid: 'nb_adid',
    zone_user_id: 'zone_user_id',
    is_debug: 'is_debug',
    member_id: 'member_idxxx',
    cif: '{"ct":"standard-cashier"}',
    oneclickpay_dispatcher: JSON.parse(`{
  "halfScreenWindow": {
    "adjustPayList": {
      "adjustInfo": "优先扣款方式",
      "userPayList": [
        {
          "description": "排序第一位的支付方式为优先扣款方式，若扣款失败将按顺序完成扣款",
          "marketPriority": 2,
          "payModeList": [
            {
              "bizId": "0",
              "payMode": 7,
              "payModeText": "美团月付",
              "payTypeUniqueKey": "creditpay"
            },
            {
              "bizId": "5062283599",
              "payMode": 2,
              "payModeText": "美团信用卡-江苏银行 (2475)",
              "payTypeUniqueKey": "quickbank_64_5062283599",
              "promoLabel": "本单首绑可减55.7元"
            },
            {
              "bizId": "0",
              "payMode": 1,
              "payModeText": "余额",
              "payTypeUniqueKey": "balancepay"
            },
            {
              "bizId": "142172612",
              "payMode": 2,
              "payModeText": "招商银行储蓄卡 (0721)",
              "payTypeUniqueKey": "quickbank_38_142172612",
              "promoLabel": "本单可减1.5元"
            },
            {
              "bizId": "5000000000002356053",
              "payMode": 16,
              "payModeText": "中国建设银行数字人民币钱包 (7232)",
              "payTypeUniqueKey": "dcep_10010000_5000000000002356053",
              "promoLabel": "本单可减0.02元"
            }
          ],
          "payType": 2,
          "secondTitle": "长按右侧图标可拖动调整扣款顺序"
        }
      ]
    },
    "button": {
      "closeBtn": {
        "buttonPath": {
          "payUrl": "cashier/dispatcher"
        }
      },
      "upBtn": {
        "buttonPath": {
          "mpmUrl": "/cashier/sethighpriority",
          "payUrl": "cashier/oneclickpay"
        },
        "buttonText": "继续支付"
      }
    },
    "decisionSource": "2",
    "guideRuleName": "rule_oneclickpay_use_guide_ccobrandedcard",
    "halfScreenType": 2,
    "oneClickPayOpenStatus": 0,
    "payTypeGuideModel": {
      "bizId": "5062283599",
      "buttonText": "立即调整",
      "coupon": "",
      "guideText": "",
      "payMode": 2,
      "payModeText": "美团信用卡-江苏银行 (2475)",
      "payTypeUniqueKey": "quickbank_64_5062283599",
      "reduce": "55.7"
    },
    "payTypeGuideStyleName": "redTextStyleWithCashTicket",
    "promoShowInfo": {
      "payModeText": "美团信用卡-江苏银行 (2475)",
      "reduce": "55.7"
    },
    "titleModel": {
      "mainTitle": "正在使用极速支付",
      "titleDesc": "人保财险保障账户安全",
      "titleDescPic": "https://p0.meituan.net/pay/54bcde0e4d4b7340798966f45112ac41752.png"
    }
  },
  "extendInfo": {
    "mtPlanId": 1585,
    "sellerId": "11000002029894",
    "oneclickpayModalUrl": "http://stable.pay.test.sankuai.com/resource/pay-deduction-part/oneclickpay-modal/0.3.0/index.html"
  },
  "routeStatus": 0,
  "cashierSessionId": "11100300000001015000000",
  "scene": "oneClickPayConfirm"
}`),
  };
}
